import { useEffect, useMemo, useState } from "react";
import MainLayout from "../components/Layout/MainLayout";
import { Button, Dropdown, Space, Typography, Collapse, Breadcrumb, Modal, Form, Input, message, Divider } from "antd";
import SearchInput from "../components/Forms/SearchInput";
import { FaChevronDown } from "react-icons/fa";
import DataTable from "../components/Tables/Datatable";
import { Link, useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useApiCall } from "../services/api";
import { TbDotsVertical } from "react-icons/tb";
import { disclaimerItems, DYED_TYPES, estimatedDispatchTimes, items, orderDetailProductsMenuItems, orderStatus } from "../constant";
import { useDispatch, useSelector } from "react-redux";
import {
  availibilityStatusMap,
  downloadFile,
  formatAddress,
  formatDate,
  getOrderLongestDispatchTime,
  handleRouteNav,
  roundDecimal,
  showAPC,
  showEstimatedDispatchTime,
} from "../utils";
import ChangeAddress from "../components/models/ChangeAddress";
import { useGlobalModal } from "../context/SuccessModalProvider";
import ConfirmStatusModal from "../components/models/ConfirmStatusModal";
import CancelOrderModal from "../components/models/CancelOrderModal";
import DispatchModal from "../components/models/DispatchModal";
import UpdateStatusModal from "../components/models/UpdateStatusModal";
import EditOrderModal from "../components/models/EditOrderModal";
import DeleteOrderItemModal from "../components/models/DeleteOrderItemModal";
// import dayjs from "dayjs";
// import utc from "dayjs/plugin/utc";
import PrimaryButton from "../components/Forms/PrimaryButton";
import ProductImageName from "../components/Layout/ProductImageName";
import CustomBadge from "../components/Charts/CustomBadge";
import { notificationRefresh } from "../redux/auth/cartRefreshSlice";
import { PiBuildingsFill, PiRowsPlusTop, PiUserCircle, PiUserCircleFill, PiWalletFill } from "react-icons/pi";
import dayjs from "dayjs";
import DispatchHistory from "../components/models/DispatchHistory";
import ViewHistoryModal from "../components/models/ViewHistoryModal";
import ViewAllCases from "../components/models/ViewAllCases";
const { Text } = Typography;
const OrderDetails = () => {
  const dispatch = useDispatch();
  const { postApi, loading } = useApiCall();
  const [orderData, setOrderData] = useState({});

  const order_items_not_dispatched = orderData?.items?.filter((item) => item.status !== orderStatus.dispatched);
  const { id } = useParams();

  const location = useLocation();
  const fromNotification = location.state?.fromNotification || false;
  const navigate = useNavigate();
  const [orderComments, setOrderComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const user_id = useSelector((state) => state.auth.user_id);
  const full_name = useSelector((state) => state.auth.full_name);
  const { is_customer, is_sales_person, role_id, customer_id, contact_person, is_admin, is_sales_manager } = useSelector((state) => state.auth);

  const [fetchRefresh, setFetchRefresh] = useState(false);
  const [categorizedProducts, setCategorizedProducts] = useState([]);

  // State hooks for controlling the visibility of each modal.
  const [modalDispatchHistory, setModalDispatchHistory] = useState(false);
  const [modal1Visible, setModal1Visible] = useState(false);
  const [modal2Visible, setModal2Visible] = useState(false);
  const [modal3Visible, setModal3Visible] = useState(false);
  const [modal4Visible, setModal4Visible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  // State hook to store the selected status from the first modal.
  const [status, setStatus] = useState(null);
  const [cancelRemark, setCancelRemark] = useState(null);
  const [defaultAddress, setDefaultAddress] = useState({
    deliveryAddress: "",
  });
  const [changeAddressModal, setChangeAddressModal] = useState(false);
  const [productToEdit, setProductToEdit] = useState(null);
  const { showPopup } = useGlobalModal();

  const orderBelongBool = (is_sales_person && user_id === orderData?.assigned_user_id) || is_admin || is_sales_manager;
  const isPlaced = orderData?.status === orderStatus.placed;
  const isProduction = orderData?.status === orderStatus.production;
  const isDispatched = orderData?.status === orderStatus.dispatched;
  const isCancelled = orderData?.status === orderStatus.cancelled;
  const isPartsCancelled = orderData?.status === orderStatus.parts_cancelled;
  const isPartsDispatched = orderData?.status === orderStatus.parts_dispatched;

  // Function to show the first modal.
  const showModal1 = () => setModal1Visible(true);
  // Function to hide the first modal.
  const handleCancel1 = () => setModal1Visible(false);
  const [modalViewHistory, setModalViewHistory] = useState(fromNotification);
  const [viewAllCases, setViewAllCases] = useState(false);

  const statusOptions = [
    (isPlaced || orderData?.items?.some((item) => item.status === orderStatus.placed)) && {
      value: "production",
      label: "In Production",
      icon: (
        <div className="flex-shrink-0 w-8 h-8 bg-red-50 rounded-full flex items-center justify-center">
          <img src="/assets/icons/GearFine.png" alt="In Production" className="w-5 h-5" />
        </div>
      ),
    },
    {
      value: "dispatched",
      label: "Dispatched",
      icon: (
        <div className="flex-shrink-0 w-8 h-8 bg-red-50 rounded-full flex items-center justify-center">
          <img src="/assets/icons/TruckTrailer.png" alt="Dispatched" className="w-5 h-5" />
        </div>
      ),
    },
    {
      value: "cancelled",
      label: "Cancel Order",
      icon: (
        <div className="flex-shrink-0 w-8 h-8 bg-red-50 rounded-full flex items-center justify-center">
          <img src="/assets/icons/Prohibit.png" alt="Cancelled" className="w-5 h-5" />
        </div>
      ),
    },
  ].filter(Boolean);

  // Function to handle the "Proceed" button click in the first modal.
  // It hides the first modal and shows the next one based on the selected status.

  const handleProceed = (status) => {
    if (
      status === "cancelled" &&
      ((isPartsDispatched && orderData.items?.some((item) => item.status === orderStatus.placed || item.status === orderStatus.production)) ||
        isPartsCancelled ||
        isDispatched)
    ) {
      return showPopup({
        title: null,
        content: (
          <span className="custom-modal-title">
            You cannot cancel a Part Dispatched order if some items aren’t dispatched. Please delete the non-dispatched items first.
          </span>
        ),
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
    }
    handleCancel1();
    if (status === "cancelled") {
      setModal2Visible(true);
    } else if (status === "production") {
      setModal3Visible(true);
    } else if (status === "dispatched") {
      setModal4Visible(true);
    }
  };

  // Handler for the "Cancel Order" button in Modal 2.
  const handleModal2Ok = async () => {
    try {
      if (!cancelRemark?.trim()) {
        return showPopup({
          title: null,
          content: <span className="custom-modal-title">Please add a remark.</span>,
          onOk: () => console.log("Confirmed!"),
          className: "custom-success-modal",
        });
      }

      const response = await postApi(
        "sales/order/cancel",
        {
          order_id: id,
          status: orderStatus.cancelled,
          cancel_date: new Date().toISOString().split("T")[0],
          cancel_remark: cancelRemark?.trim(),
          updated_by_id: user_id,
          updated_by: full_name,

          indent_no: orderData?.indent_no,
        },
        true,
      );
      if (response && response.status) {
        setModal2Visible(false);
        dispatch(notificationRefresh());
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
    } finally {
      fetchOrder();
      setStatus(null);
    }
  };

  // Handler for the "Update Status" button in Modal 3.
  const handleModal3Ok = async (item_ids) => {
    try {
      item_ids = orderData?.items
        .filter((item) => item_ids.includes(item.order_item_id) && item.status !== "In Production")
        .map((item) => item.order_item_id);
      if (item_ids.length === 0) {
        return showPopup({
          title: null,
          content: <span className="custom-modal-title">Please select at least one item.</span>,
          onOk: () => console.log("Confirmed!"),
          className: "custom-success-modal",
        });
      }

      const response = await postApi(
        "sales/order/items-in-production",
        {
          order_id: id,
          item_ids: Array.isArray(item_ids) ? item_ids.join(",") : item_ids,
          status: orderStatus.production,
          updated_by_id: user_id,
          updated_by: full_name,
        },
        true,
      );

      if (response && response.status) {
        dispatch(notificationRefresh());
        setModal3Visible(false);
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
    } finally {
      fetchOrder();
      setStatus(null);
    }
  };

  const handleModal4Ok = async (values, form) => {
    try {
      const finalItemsStatus = Object.entries(values.items).reduce((acc, [key, value]) => {
        if (value) {
          acc[key] = value;
        }
        return acc;
      }, {});

      if (!finalItemsStatus || Object.values(finalItemsStatus).length === 0) {
        return showPopup({
          content: <span className="custom-modal-title">Please dispatch at least one item.</span>,
          className: "custom-success-modal",
        });
      }

      const formData = new FormData();
      formData.append("order_id", id);
      formData.append("dispatch_date", (values.dispatch_date || dayjs(orderData.dispatch_date))?.format("YYYY-MM-DD"));
      formData.append("updated_by_id", user_id);
      formData.append("updated_by", full_name);

      formData.append("item_ids", Object.keys(finalItemsStatus).join(","));
      formData.append("status_list", Object.values(finalItemsStatus).join(","));

      if (values.invoice?.[0]) {
        formData.append("invoice", values.invoice[0].originFileObj);
      }

      if (values.transport?.[0]) {
        formData.append("transport_details", values.transport[0].originFileObj);
      }

      const response = await postApi("sales/order/dispatched", formData, true);
      if (response?.status) {
        setModal4Visible(false);
        dispatch(notificationRefresh());
        form.resetFields();
      }
    } finally {
      fetchOrder();
    }
  };

  const handleEditModalSave = async (values) => {
    try {
      const totalCases = productToEdit?.update_total_cases ?? productToEdit?.cases;
      const totalMeters = productToEdit?.update_total_meter ?? productToEdit?.quantity_meters;
      const tdlevelcode = productToEdit?.update_tdlevelcode ?? productToEdit?.tdlevel_code ?? productToEdit?.quality_tdlevel_code;
      const tdlevelname = productToEdit?.update_tdlevelname ?? productToEdit?.tdlevel_name ?? productToEdit?.quality_tdlevel_name;
      const response = await postApi(
        is_customer ? "order/order-updates" : "sales/order/updates",
        {
          order_item_id: productToEdit.order_item_id,
          update_total_cases: `${Number(totalCases)}`,
          update_total_meter: roundDecimal(totalMeters),
          updated_by_id: is_customer ? customer_id : user_id,
          updated_by: is_customer ? contact_person : full_name,
          tdlevel_code: tdlevelcode || undefined,
          tdlevel_name: tdlevelname || undefined,
          indent_id: productToEdit.indent_id,
        },
        true,
      );

      if (response && response.status) {
        setEditModalVisible(false);
        dispatch(notificationRefresh());
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
    } finally {
      fetchOrder();
      setProductToEdit(null);
    }
  };

  const handleDeleteModalSave = async () => {
    try {
      const response = await postApi(
        "sales/order/item-delete",
        {
          order_item_id: productToEdit.order_item_id,
          updated_by_id: user_id,
          updated_by: full_name,

          indent_id: productToEdit.indent_id,
        },
        true,
      );

      if (response && response.status) {
        setDeleteModalVisible(false);
        dispatch(notificationRefresh());
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
    } finally {
      fetchOrder();
      setProductToEdit(null);
    }
  };

  // Function to handle the file list for Ant Design's Upload component.
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  // Custom SVG icon for the upload button to match the design.
  const UploadIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 16V4M12 4L16 8M12 4L8 8M4 16V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V16"
        stroke="#6B2F31"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const columns = [
    {
      title: "#",
      dataIndex: "product_picture_url",
      key: "product_picture_url",
      render: (value, item) => {
        return <ProductImageName img_url={value} img_alt={item.short_name} />;
      },
      ellipsis: true,
      width: 100,
    },
    {
      title: "Shade",
      dataIndex: "shade_name",
      key: "shade_name",
      ellipsis: true,
      render: (value, item) => value + showAPC(item.apc_no) || "-",
    },
    {
      title: "Dyed type",
      dataIndex: "dye_type",
      key: "dye_type",
      ellipsis: true,
    },
    {
      title: "Cases",
      dataIndex: "cases",
      key: "cases",
      render: (_, item) => {
        return `${item.update_total_cases || item.cases || "0"} cases`;
      },
      ellipsis: true,
    },
    {
      title: "Quantity",
      key: "quantity_meters",
      render: (_, item) => `${roundDecimal(item.update_total_meter || item.quantity_meters) || "0"}m`,
      ellipsis: true,
    },
    {
      title: "Availability",
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        const hasStock = Number(item.in_stock) > 0 || Number(item.in_stock_folding) > 0;
        const hasGrey = Number(item.in_stock_grey) > 0;

        const status = hasStock ? availibilityStatusMap.IN_STOCK : hasGrey ? availibilityStatusMap.GREY : availibilityStatusMap.MTO;

        const displayText = status.key === availibilityStatusMap.GREY.key ? status.text.split(" ")[0] : status.text;

        return (
          <div className="w-full flex items-center py-2">
            <CustomBadge variant={status.variant} text={displayText} />
          </div>
        );
      },
      ellipsis: true,
    },
    {
      title: "Estimated Dispatch",
      key: "estimated_dispatch",
      render: (_, item) => {
        if (
          item.status === orderStatus.dispatched ||
          orderData.status === orderStatus.dispatched ||
          orderData.status === orderStatus.cancelled ||
          orderData.status === orderStatus.parts_cancelled
        )
          return "-";
        return (
          showEstimatedDispatchTime(item, {
            getLength: 1,
            skipFullStop: true,
          }) || "-"
        );
      },
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      ellipsis: true,
      render: (value) => value || "-",
    },
    {
      title: "Trade Level",
      dataIndex: "tdlevel_name",
      key: "tdlevel_name",
      ellipsis: true,
      render: (value) => value || "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      fixed: "right",
      ellipsis: true,
      render: (value) => value || "-",
    },
    {
      title: "",
      key: "action",
      fixed: "right",
      render: (_, record, index) => {
        const handleReorderNav = () =>
          navigate(handleRouteNav(`/product-details/${record.sort_no}`, role_id), {
            state: {
              shade_no: record.shade_no,
              order_cases_no: record.update_total_cases || record.cases,
              comments: record.comments,
              order_item_dyed_type: record.dye_type,
              apc_no: record.apc_no,
              cart_item_tdlevel_code: record.tdlevel_code,
            },
          });

        return (
          <div className="flex gap-2 items-center">
            {record?.status === orderStatus.dispatched ||
            record?.status === orderStatus.cancelled ||
            isDispatched ||
            isCancelled ||
            isPartsCancelled ||
            is_customer ||
            !orderBelongBool ? (
              <button onClick={handleReorderNav}>{orderDetailProductsMenuItems[0]?.label}</button>
            ) : (
              <Dropdown
                menu={{
                  // items: orderDetailProductsMenuItems.filter((item) =>
                  //   item.key === "3" ? index + 1 === foundProduct.items.length : true
                  // ),
                  items: orderDetailProductsMenuItems.filter((item) => {
                    if (record?.status === orderStatus.parts_dispatched) {
                      return item.key !== "3";
                    }
                    return true;
                  }),
                  onClick: ({ key, domEvent }) => {
                    domEvent.stopPropagation();
                    switch (key) {
                      case "1":
                        handleReorderNav();
                        break;
                      case "2":
                        setEditModalVisible(true);
                        setProductToEdit(record);
                        break;
                      case "3":
                        const foundProduct = categorizedProducts.find((item) => item.sort_no === record.sort_no);
                        if (categorizedProducts.length === 1 && foundProduct.items.length === 1) {
                          return showPopup({
                            title: null,
                            content: (
                              <span className="custom-modal-title">You cannot delete the only product in this order. Cancel the order instead.</span>
                            ),
                            onOk: () => console.log("Confirmed!"),
                            className: "custom-success-modal",
                          });
                        }

                        setDeleteModalVisible(true);
                        setProductToEdit(record);
                        break;
                      default:
                        break;
                    }
                  },
                }}
                trigger={["click"]}
                overlayClassName="custom-dropdown-sales-menu"
              >
                <Typography.Link
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  <Space>
                    <TbDotsVertical className="text-red-700" size={18} />
                  </Space>
                </Typography.Link>
              </Dropdown>
            )}
          </div>
        );
      },
    },
  ];

  const fetchComments = async () => {
    try {
      const response = await postApi("sales/order/get-comments", {
        order_id: id,
      });
      if (!response) return;
      setOrderComments(response.data || []);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const fetchOrder = async () => {
    try {
      const response = await postApi(
        is_customer ? "order/get-order-with-id" : "sales/order/get-order-with-id",
        {
          order_id: id,
          user_type: is_customer ? "Customer" : "User",
          customer_id: is_customer ? customer_id : undefined,
          user_id: !is_customer ? user_id : undefined,
        },
        false,
      );

      if (!response?.status) {
        return showPopup({
          title: null,
          content: <span className="custom-modal-title">{response?.message}</span>,
          onOk: () => (response.is_blocked || response.is_deleted ? null : navigate(-1)),
          className: "custom-success-modal",
        });
      }

      setOrderData(response.data || {});

      const tempCategorizedProducts = [];
      const uniqueProducts = new Set();
      const orderItems = response.data?.items || [];

      orderItems.forEach((item) => {
        uniqueProducts.add(item.sort_no);
      });

      orderItems.forEach((item) => {
        const existing = tempCategorizedProducts.find((cat) => cat.sort_no === item.sort_no);
        if (existing) {
          existing.items.push(item);
        } else {
          tempCategorizedProducts.push({
            sort_no: item.sort_no,
            items: [item],
          });
        }
      });

      setCategorizedProducts(tempCategorizedProducts);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const handleAddComment = async () => {
    try {
      const response = await postApi(
        "sales/order/add-comment",
        {
          order_id: id,
          comment: newComment?.trim(),
          user_id,
          updated_by: full_name,
          updated_by_id: user_id,
        },
        true,
      );
      if (!response) return;
      setNewComment("");
      fetchComments();
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (!newComment?.trim()) {
        return showPopup({
          title: null,
          content: <span className="custom-modal-title">Please add a comment</span>,
          onOk: () => console.log("Confirmed!"),
          className: "custom-success-modal",
        });
      }
      handleAddComment();
    }
  };

  useEffect(() => {
    fetchComments();
  }, []);

  useEffect(() => {
    fetchOrder();
  }, [fetchRefresh]);

  useEffect(() => {
    const updateDeliveryAddress = async () => {
      if (!defaultAddress?.deliveryAddress) return;

      const deliveryAddressString = formatAddress(defaultAddress?.deliveryAddress);

      try {
        const response = await postApi(
          "sales/order/update-delivery-address",
          {
            order_id: id,
            delivery_title: defaultAddress?.deliveryAddress?.title,
            delivery_address: deliveryAddressString,
            updated_by_id: user_id,
            updated_by: full_name,

            delivery_city: defaultAddress?.deliveryAddress?.city || "",
            indent_no: orderData?.indent_no,
          },
          true,
        );
        if (response && response.status) {
          fetchOrder();
          dispatch(notificationRefresh());
        }
      } catch (error) {
        console.error("Error updating delivery address:", error);
      }
    };
    updateDeliveryAddress();
  }, [defaultAddress]);

  const { setTitle, setDescription, setBackButton } = useOutletContext();

  useEffect(() => {
    setTitle("Order Details");
    setDescription(
      <div>
        <Breadcrumb>
          {[
            { title: "Home", href: handleRouteNav("", role_id) },
            {
              title: is_customer ? "My Orders" : "Orders",
              href: handleRouteNav("/orders", role_id),
            },
            {
              title: "Order Details",
              href: handleRouteNav(`/orders/${id}`, role_id),
            },
          ].map((item, index) => (
            <Breadcrumb.Item key={index}>
              <Link to={item.href}>{item.title}</Link>
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </div>,
    );
    setBackButton(true);
  }, [setTitle, setDescription, setBackButton]);

  const orderPlacedText = useMemo(() => {
    const prefix = "Order Placed by: ";

    if (orderData?.user === null) {
      if (customer_id?.toString() === orderData?.customer_id?.toString()) {
        return `${prefix} YOU`;
      }

      if (orderData?.customer === null) {
        return `${prefix} Client`;
      }

      return `${prefix} ${orderData?.customer?.company_name ?? "-"} | Client`;
    }

    return `${prefix} ${orderData?.user?.full_name ?? "-"} | Sales`;
  }, [orderData, customer_id, user_id]);

  return (
    <>
      <>
        <div className="pb-7 relative">
          <div className="flex justify-between items-center gap-4">
            {!is_customer && (
              <div>
                <PrimaryButton
                  text="View Case Nos."
                  icon={<PiRowsPlusTop className="text-[#ffff]" />}
                  onClick={(e) => {
                    setViewAllCases(true);
                  }}
                  iconOnleft
                  btnType="ghost"
                />
              </div>
            )}
            <div className={`${is_customer ? "absolute" : ""} top-[-60px] right-0 flex flex-col justify-end text-end text-black mb-3 leading-normal`}>
              <span className="text-lg">
                Order ID: {orderData.order_id} | Indent No: {orderData?.indent_no}
              </span>
              <span className="text-md font-semibold">{orderPlacedText}</span>
              {!is_customer && orderData?.user !== null && orderData?.customer !== null && (
                <span className="text-md">Client: {orderData?.customer?.company_name}</span>
              )}
            </div>
          </div>

          <div className="bg-[#FFFFFF] leading-normal" style={{ borderRadius: "32px", overflow: "hidden" }}>
            <div className="flex gap-3 w-100 justify-between text-black px-5 py-6">
              <div className="flex gap-4">
                <div className="flex gap-3 justify-center items-center">
                  <div className="w-[50px] h-[50px] bg-[#A334341A] rounded-full flex items-center justify-center">
                    <img src="/assets/icons/cube.png" alt="Cube" className="w-auto h-[30px] object-contain" />
                  </div>

                  <div className="flex flex-col text-start">
                    <span className="text-gray-500">Order Placed On:</span>
                    <span className="text-start">{formatDate(orderData?.created_at)}</span>
                  </div>
                </div>
                {isProduction && (
                  <div className="flex gap-3 justify-center items-center">
                    <div className="w-[50px] h-[50px] bg-[#A334341A] rounded-full flex items-center justify-center">
                      <img src="/assets/icons/GearFine.png" alt="Cube" className="w-auto h-[30px] object-contain" />
                    </div>

                    <div className="flex flex-col items-center">
                      <span className="text-gray-500">In Production</span>
                    </div>
                  </div>
                )}

                {(isDispatched || isPartsDispatched) && (
                  <div className="flex gap-3 justify-center items-center">
                    <div className="w-[50px] h-[50px] bg-[#A334341A] rounded-full flex items-center justify-center">
                      <img src="/assets/icons/TruckTrailer.png" alt="Cube" className="w-auto h-[30px] object-contain" />
                    </div>

                    <div className="flex flex-col text-start">
                      <span className="text-gray-500">
                        {isPartsDispatched ? "Part" : ""} Dispatched {isDispatched ? "On" : ""}:
                      </span>
                      <span className="text-start">{formatDate(orderData?.dispatch_date)}</span>
                    </div>
                  </div>
                )}

                {(isCancelled || isPartsCancelled) && (
                  <div className="flex gap-3 justify-center items-center">
                    <div className="w-[50px] h-[50px] bg-[#A334341A] rounded-full flex items-center justify-center">
                      <img src="/assets/icons/Prohibit.png" alt="Cube" className="w-auto h-[30px] object-contain" />
                    </div>

                    <div className="flex flex-col text-start">
                      <span className="text-gray-500">{isPartsCancelled ? "Part Cancelled" : "Order Cancelled"}:</span>
                      <span className="text-start">{formatDate(orderData?.cancel_date)}</span>
                    </div>
                  </div>
                )}
              </div>

              {(isPlaced || isProduction) && !is_customer && orderBelongBool ? (
                <PrimaryButton
                  text="Update Status"
                  icon={<img src="/assets/icons/ClockClockwise.png" alt="Cube" className="w-auto h-[20px] object-contain" />}
                  onClick={(e) => {
                    showModal1();
                  }}
                  iconOnleft
                  btnType="ghost"
                />
              ) : isCancelled ? (
                <div className="flex gap-3 justify-center items-center">
                  <div className="w-[50px] h-[50px] bg-[#A334341A] rounded-full flex items-center justify-center">
                    <img src="/assets/icons/User.png" alt="User" className="w-auto h-[30px] object-contain" />
                  </div>

                  <div className="flex flex-col text-start">
                    <span className="text-black">
                      Cancelled By - <b>{orderData?.update_by_user?.full_name || "N/A"}</b>
                    </span>
                    <span className="text-start">{orderData?.cancel_remark}</span>
                  </div>
                </div>
              ) : isDispatched || isPartsDispatched ? (
                <div className="flex flex-wrap gap-3 lg:justify-end items-center">
                  <PrimaryButton
                    text="Dispatch History"
                    icon={<img src="/assets/icons/Dispatch-history.svg" alt="Article" className="w-auto h-[20px] object-contain" />}
                    onClick={() => setModalDispatchHistory(true)}
                    iconOnleft
                    btnType="ghost"
                  />
                  {isPartsDispatched && !is_customer && orderBelongBool && (
                    <>
                      <Divider type="vertical" style={{ height: "30px" }} />
                      <PrimaryButton
                        text="Update Status"
                        icon={<img src="/assets/icons/ClockClockwise.png" alt="Cube" className="w-auto h-[20px] object-contain" />}
                        onClick={(e) => {
                          showModal1();
                        }}
                        iconOnleft
                        btnType="ghost"
                      />
                    </>
                  )}
                </div>
              ) : isPartsCancelled ? (
                <PrimaryButton
                  text="Dispatch History"
                  icon={<img src="/assets/icons/Dispatch-history.svg" alt="Article" className="w-auto h-[20px] object-contain" />}
                  onClick={() => setModalDispatchHistory(true)}
                  iconOnleft
                  btnType="ghost"
                />
              ) : (is_customer || !orderBelongBool) && (isProduction || isPlaced) ? (
                <div className="flex items-center justify-end gap-3">
                  {/* Truck icon inside background circle */}
                  <div className="flex-shrink-0 w-[50px] h-[50px] bg-red-50 rounded-full flex items-center justify-center">
                    <img src="/assets/icons/TruckTrailer.png" alt="Truck" className="w-[30px] h-[30px] object-contain" />
                  </div>
                  <div className="flex flex-col">
                    <Text className="text-left text-gray-700">
                      <strong>Estimated Dispatch</strong> - {getOrderLongestDispatchTime(order_items_not_dispatched)}
                    </Text>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          {categorizedProducts.map((product) => (
            <div className="bg-[#FFFFFF] leading-normal mt-7 p-3" style={{ borderRadius: "32px", overflow: "hidden" }}>
              <Collapse
                defaultActiveKey={["1"]}
                ghost
                expandIconPosition="end"
                expandIcon={({ isActive }) => (
                  <FaChevronDown
                    className="transition-transform duration-300 mt-2"
                    style={{
                      transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                )}
                items={[
                  {
                    key: "1",
                    label: (
                      <div className="flex justify-between items-center w-full">
                        <span className="text-xl font-semibold text-gray-800">{product.items[0]?.short_name}</span>
                        {/* {+product.items[0]?.price_per_meter > 0 && (
                          <span className="text-lg font-medium text-gray-700">
                            ₹{product.items[0]?.price_per_meter} / meter
                          </span>
                        )} */}
                      </div>
                    ),
                    children: <DataTable columns={columns} data={product.items} Showpagination={false} disableHover />,
                  },
                ]}
              />
            </div>
          ))}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-[#FFFFFF] leading-normal mt-7 text-black" style={{ borderRadius: "32px", overflow: "hidden" }}>
              <div className="flex flex-wrap gap-2 w-100 justify-between px-5 py-6">
                <div className="flex gap-4">
                  <div className="flex gap-3 justify-center items-center">
                    <div className="w-[50px] h-[50px] bg-[#A334341A] rounded-full flex items-center justify-center">
                      <PiBuildingsFill size={24} fill="#A33434" />
                    </div>

                    <div className="flex flex-col">
                      <span className="text-black text-lg">Deliver to</span>
                    </div>
                  </div>
                </div>
                {!is_customer && orderBelongBool && [orderStatus.production, orderStatus.placed].includes(orderData?.status) && (
                  <PrimaryButton
                    text="Change Address"
                    icon={<img src="/assets/icons/Repeat.png" alt="Cube" className="w-auto h-[16px] object-contain" />}
                    onClick={(e) => {
                      e.stopPropagation();
                      setChangeAddressModal(true);
                    }}
                    iconOnleft
                    btnType="ghost"
                  />
                )}
              </div>

              <div className="w-100 justify-between px-5 pb-5">
                <div className="border rounded-[32px] py-5 px-5 items-center text-start">
                  <h3 className="w-100 text-lg font-semibold">{orderData?.delivery_title ? orderData?.delivery_title + ":" : null}</h3>
                  {orderData?.delivery_address}
                </div>
              </div>
            </div>
            <div className="bg-[#FFFFFF] leading-normal mt-7 text-black" style={{ borderRadius: "32px", overflow: "hidden" }}>
              <div className="flex w-100 justify-between px-5 py-6">
                <div className="flex gap-4">
                  <div className="flex gap-3 justify-center items-center">
                    <div className="w-[50px] h-[50px] bg-[#A334341A] rounded-full flex items-center justify-center">
                      <PiWalletFill size={24} fill="#A33434" />
                    </div>

                    <div className="flex flex-col">
                      <span className="text-black text-lg">Bill to</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-100 justify-between px-5 pb-5">
                <div className="border rounded-[32px] py-5 px-5 items-center text-start">
                  <h3 className="w-100 text-lg font-semibold">{orderData?.billing_title ? orderData?.billing_title + ":" : null}</h3>
                  {orderData?.billing_address}
                </div>
              </div>
            </div>
          </div>
          {!is_customer && orderBelongBool && (
            <>
              {(isCancelled || isDispatched || isPartsCancelled) && orderComments?.length === 0 ? null : (
                <div className="bg-[#FFFFFF] leading-normal mt-7 text-black" style={{ borderRadius: "32px", overflow: "hidden" }}>
                  <div className="flex w-100 justify-between px-5 py-6">
                    <div className="flex gap-4">
                      <div className="flex gap-3 justify-center items-center">
                        <div className="w-[50px] h-[50px] bg-[#A334341A] rounded-full flex items-center justify-center">
                          <PiUserCircle size={24} fill="#A33434" />
                        </div>

                        <div className="flex flex-col">
                          <span className="text-black text-md xl:text-lg">Comments</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-100 justify-between px-5 pb-5">
                    {orderComments?.length > 0 && (
                      <div className="border rounded-[32px] py-5 px-5 items-center text-start">
                        <ul className="list-disc pl-5">
                          {orderComments.map((comment) => (
                            <li key={comment.comment_id} className="mb-2 last:mb-0">
                              <div className="grid grid-cols-1 sm:grid-cols-[minmax(0,1fr)_420px] gap-1 sm:gap-4">
                                <span className="min-w-0 break-words">{comment.comment}</span>
                                <div className="text-sm text-gray-500 sm:text-right sm:w-[420px] sm:max-w-[420px] sm:min-w-0 sm:justify-self-end sm:overflow-hidden">
                                  <span
                                    className="block w-full sm:truncate"
                                    title={`By ${comment.updated_by || "-"} (${formatDate(comment.updated_at, {
                                      format: "DD MMM YYYY h:mma",
                                    })})`}
                                  >
                                    By {comment.updated_by || "-"} (
                                    {formatDate(comment.updated_at, {
                                      format: "DD MMM YYYY h:mma",
                                    })}
                                    )
                                  </span>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {(isPlaced || isProduction || isPartsDispatched) && (
                <>
                  <div className="bg-[#FFFFFF] leading-normal mt-7 text-black" style={{ borderRadius: "32px", overflow: "hidden" }}>
                    <Input
                      type="text"
                      className="w-full border border-gray-200 rounded-[32px] py-5 px-5 items-center text-start"
                      placeholder="Write your new comment here"
                      onKeyDown={handleKeyDown}
                      onChange={(e) => setNewComment(e.target.value)}
                      value={newComment}
                    />
                  </div>
                </>
              )}
            </>
          )}

          {is_customer && (
            <div className="bg-[#FFFFFF] leading-normal mt-7 text-black" style={{ borderRadius: "32px", overflow: "hidden" }}>
              <div className="flex w-100 justify-between px-5 py-6">
                <div className="flex gap-4">
                  <div className="flex gap-3 justify-center items-center">
                    <div className="w-[50px] h-[50px] bg-[#A334341A] rounded-full flex items-center justify-center">
                      <PiUserCircleFill size={24} fill="#A33434" />
                    </div>

                    <div className="flex items-center gap-1 text-black">
                      <span className="text-md font-semibold">Contact Us -</span>
                      <span className="text-md">
                        For any queries or further information related to this order, please contact your sales representative.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {orderData?.update_by_user?.full_name && (
            <div className="flex items-center justify-end leading-normal text-black mt-3 text-[20px]">
              <span>
                Last Edited {orderData?.updated_at && <>on {formatDate(orderData?.updated_at)}</>}{" "}
                {orderData?.update_by_user?.full_name && (
                  <>
                    by - <b>{orderData?.update_by_user?.full_name}</b>
                  </>
                )}
              </span>
            </div>
          )}
        </div>
        <div className="flex flex-wrap gap-3 lg:justify-end items-center">
          <img onClick={() => setModalViewHistory(true)} src="/assets/icons/view-history.svg" alt="Article" className="cursor-pointer" />
          <h4 onClick={() => setModalViewHistory(true)} className="underilne cursor-pointer text-lg font-bold text-[#a33434]">
            View Edit History
          </h4>
        </div>

        <div className={is_customer ? "pb-10 pt-6 rounded-lg" : "pt-6 rounded-lg"}>
          <div className="flex items-center gap-3 mb-6">
            <h2 className="text-2xl font-semibold text-gray-800">Disclaimers</h2>
          </div>

          <div className="space-y-4">
            {disclaimerItems.map((item, index) => (
              <div key={index} className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1.5">
                  <div className="w-2 h-2 bg-[#A33434] rounded-full"></div>
                </div>
                <p className="flex-1 text-left text-gray-600 leading-relaxed text-sm">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </>
      <ChangeAddress
        isMainModalOpen={changeAddressModal}
        setIsMainModalOpen={setChangeAddressModal}
        customer_id={[orderStatus.production, orderStatus.placed].includes(orderData?.status) && orderData?.customer_id}
        defaultAddress={defaultAddress}
        setDefaultAddress={setDefaultAddress}
      />

      <UpdateStatusModal
        open={modal1Visible}
        onClose={handleCancel1}
        handleSubmit={handleProceed}
        title="Update Status"
        options={statusOptions}
        loading={loading}
      />

      <CancelOrderModal
        open={modal2Visible}
        onClose={() => setModal2Visible(false)}
        handleSubmit={handleModal2Ok}
        cancelRemark={cancelRemark}
        setCancelRemark={setCancelRemark}
        loading={loading}
        orderData={orderData}
      />

      {/* Modal 3: Update to Production */}
      <ConfirmStatusModal
        open={modal3Visible}
        onClose={() => setModal3Visible(false)}
        handleSubmit={handleModal3Ok}
        title="Update to Production"
        loading={loading}
        orderData={orderData}
        width={450}
      />

      {/* Modal 4: Update to Dispatch */}
      <DispatchModal
        open={modal4Visible}
        onClose={() => setModal4Visible(false)}
        handleSubmit={handleModal4Ok}
        loading={loading}
        orderData={orderData}
      />

      {/* Modal: Edit Order Details */}
      <EditOrderModal
        open={editModalVisible}
        onClose={() => {
          setEditModalVisible(false);
          setProductToEdit(null);
        }}
        handleSubmit={handleEditModalSave}
        productToEdit={productToEdit}
        setProductToEdit={setProductToEdit}
        loading={loading}
      />

      {/* Modal: Delete Order item */}
      <DeleteOrderItemModal
        open={deleteModalVisible}
        // onClose={() => setDeleteModalVisible(false)}
        onClose={() => {
          setDeleteModalVisible(false);
          setProductToEdit(null);
        }}
        handleSubmit={handleDeleteModalSave}
        productToEdit={productToEdit}
        title="Do you want to delete this item?"
        loading={loading}
      />

      <DispatchHistory orderData={orderData} open={modalDispatchHistory} loading={loading} onClose={() => setModalDispatchHistory(false)} />

      <ViewHistoryModal
        orderData={orderData}
        open={modalViewHistory}
        loading={loading}
        onClose={() => {
          setModalViewHistory(false);
        }}
        setFetchRefresh={setFetchRefresh}
      />

      <ViewAllCases orderData={orderData} open={viewAllCases} loading={loading} onClose={() => setViewAllCases(false)} />
    </>
  );
};

export default OrderDetails;
